// Feature flag controlling visibility of the Group Management UI.
// Toggle in the FeatureFlag system; the route, sidebar entry, and page
// content are all gated on this name.
export const GROUPS_MANAGEMENT_FEATURE_FLAG = "groups_management_ui";
